import { Loader } from "@tql/ui-components-react/kendo/indicators";
import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";
import type { ReactNode } from "react";
import { Fragment } from "react";

/**
 * Shared "message feed" list: a loader while a mutation is in flight, otherwise
 * the items grouped by date (each group is a card headed by its date). The
 * caller supplies how to render and key each item, so the differing item
 * components and key derivations never leak into this component.
 */
export function GroupedFeedList<T>({
	groups,
	isLoading,
	getItemKey,
	renderItem,
}: Readonly<{
	groups?: Record<string, T[]>;
	isLoading: boolean;
	getItemKey: (item: T) => string;
	renderItem: (item: T) => ReactNode;
}>) {
	return (
		<CardBody className={"grouped-feed-list"}>
			<div className={"card-spacers"}>
				{isLoading ? (
					<div className={"tracking-loader"}>
						<Loader size={"medium"} type={"infinite-spinner"} />
					</div>
				) : (
					Object.keys(groups ?? {}).map((date) => (
						<Card key={date} className={"remark-card"}>
							<CardHeader>
								<p className={"centered-header-text"}>{date}</p>
							</CardHeader>
							<div className={"remark-card-body"}>
								{groups?.[date]?.map((item) => (
									<Fragment key={getItemKey(item)}>{renderItem(item)}</Fragment>
								))}
							</div>
						</Card>
					))
				)}
			</div>
		</CardBody>
	);
}
